<template>
  <div v-if="visible">
    <template>
      <div class="iframe-wrap">
        <iframe
          :src="url"
          frameborder="0"
          scrolling="yes"
          style="height: 100%; width: 100%; background-color: black;"
          @load="iframeLoaded"
        ></iframe>
        <div
          class="closebtn"
          @click="closeWindow()"
        ></div>
      </div>
    </template>
  </div>
</template>
<script>
import { DEVICE_TYPE } from "@/constant";

export default {
  data() {
    return {
      visible: false,
      needForceLandscape: false,
      loaded: false,
      url: "",
      isMobile: DEVICE_TYPE.isMobile,
      width: this.isMobile ? "100%" : "600px",
      height: this.isMobile ? "100%" : "400px",
    };
  },
  mounted() {},
  methods: {
    getMessage(value) {
      console.log(value);
    },
    show() {
      this.visible = true;
    },
    closeWindow() {
      this.visible = false;
    },
    iframeLoaded() {},
  },
};
</script>
<style lang="less" scoped>
iframe::-webkit-scrollbar {
  display: none;
}

::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.iframe-wrap {
  text-align: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
  overflow-x: scroll;
  height: 100%;
  width: 100%;
  z-index: 4;
}
.closebtn {
  background-image: url(../../assets/hok/guanbi.png);
  position: fixed;
  right: 5vmin;
  top: 5vmin;
  color: black;
  // cursor: pointer;
  background-size: 100% 100%;
  width: 30px;
  height: 30px;
  z-index: 4;
}
</style>